import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * SideBar component styles
 * @returns {Function}
 */
export const useStyles = makeStyles((theme) =>
  createStyles({
    sideBar: {
      backgroundColor: variables.colorV2.navigation.primary.background.default,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden',
      padding: theme.spacing(2.75, 2),
      transition: 'width 0.3s ease',
      width: variables.sideBar.width,

      '&$expanded': {
        width: '25.6rem',

        '& $navItemText': {
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },

        '& $navDividerTextPrimary': {
          '& > span': {
            display: 'inline',
          },

          '&::after': {
            transform: 'translateY(-50%)',
          },
        },
      },
    },

    logo: {
      margin: 'auto -62px 77px',
      transform: 'rotate(-90deg)',
      width: '163px',
    },

    navItemIcon: {
      border: '1px solid transparent',
      borderRadius: '.8rem',
      height: '4.4rem',
      minWidth: 'auto',
      width: '4.4rem',
    },

    navItemIconFill: {
      fill: variables.colorV2.navigation.primary.icon.fill.default,
    },

    navItemIconStroke: {
      stroke: variables.colorV2.navigation.primary.icon.stroke.default,
    },

    navItem: {
      // borderRadius: variables.borderRadius.sm,
      color: variables.colorV2.navigation.primary.text.default,
      cursor: 'pointer',
      flexDirection: 'column',
      marginTop: '.8rem',
      paddingTop: '.4rem',
      padding: '0 0', // theme.spacing(0.75, 1),

      '&$selected, &$selected:hover': {
        background: variables.colorV2.navigation.primary.background.active,

        '& $navItemTextPrimary': {
          color: variables.colorV2.navigation.primary.text.active,
        },

        '& $navItemIconFill': {
          fill: variables.colorV2.navigation.primary.icon.fill.active,
        },

        '& $navItemIconStroke': {
          stroke: variables.colorV2.navigation.primary.icon.stroke.active,
        },

        '& $navItemIcon': {
          border: `2px solid ${variables.colorV2.navigation.primary.border.active}`,
          minWidth: 'auto',
        },
      },

      '&:hover': {
        background: variables.colorV2.navigation.primary.background.hover,

        '& $navItemIconFill': {
          fill: variables.colorV2.navigation.primary.icon.fill.hover,
        },

        '& $navItemIconStroke': {
          stroke: variables.colorV2.navigation.primary.icon.stroke.hover,
        },

        '& $navItemTextPrimary': {
          color: variables.colorV2.navigation.primary.text.hover,
        },

        '& $navItemIcon': {
          minWidth: 'auto',
          outline: `2px solid ${variables.colorV2.navigation.primary.border.active}`,
        },
      },

      '& svg': {
        margin: 'auto auto',
      },

      '&:not(:last-child)': {
        marginBottom: theme.spacing(0.25),
      },
    },

    navItemText: {
      // display: 'none',
      // marginLeft: theme.spacing(2),
      marginTop: '.2rem',
      marginBottom: 0,
      paddingTop: '.6rem',
    },

    navItemTextPrimary: {
      color: variables.colorV2.navigation.primary.text.active,
      fontSize: '1.1rem',
      fontWeight: 600,
      lineHeight: variables.lineHeight.lg,
    },

    navDivider: {
      padding: theme.spacing(2, 1, 1),
      overflowX: 'hidden',
    },

    navDividerText: {
      marginTop: 0,
      marginBottom: 0,
    },

    navDividerTextPrimary: {
      fontSize: variables.font.size.xxxs,
      fontWeight: variables.font.weight.bold,
      color: 'rgba(144, 163, 200, 0.6)',
      lineHeight: variables.lineHeight.xxxs,
      height: variables.lineHeight.xxxs,
      textTransform: 'uppercase',
      position: 'relative',

      '& > span': {
        display: 'none',
        backgroundColor: variables.color.primary.darkestPurple,
        paddingRight: theme.spacing(1),
        position: 'relative',
        zIndex: 1,
      },

      '&::after': {
        content: '""',
        display: 'block',
        position: 'absolute',
        height: '0.1rem',
        background: 'rgba(144, 163, 200, 0.3)',
        width: '99rem',
        top: '50%',

        transform: 'translateY(-50%) translateX(-8px)',
      },
    },

    expanded: {},
    selected: {},
  }),
);
